import React from "react";
import { Stack, Box, Typography, Tooltip } from "@mui/material"
import LockIcon from "@mui/icons-material/Lock";

interface MenuSpanHeaderProps {
  matchName: string;
  label: string;
  accountTabValue: string;
  setViewEvent: (event: any) => void;
  setAccountTabValue: (value: string) => void;
  onClick?: () => void;
  locked?: boolean;
  lockTooltip?: string;
}

const MenuSpanHeader: React.FC<MenuSpanHeaderProps> = ({ matchName, label, accountTabValue, setViewEvent, setAccountTabValue, onClick, locked, lockTooltip }) => {

  return (
    <Stack direction={'row'} spacing={2} alignItems={'center'} padding={'3px 1px'}
        onClick={() => { 
          if (locked) return;
          if (onClick) {
            onClick();
          } else {
            setAccountTabValue(matchName);
            if (matchName !== 'registrations') {
              setViewEvent(null);
            }
          }
        }}
        sx={{ 
          width: '100%',
          height: 30,
          cursor: locked ? 'default' : 'pointer',
          backgroundColor: accountTabValue === matchName ? 'primary.extraLight' : 'transparent',
          '&:hover': {
            backgroundColor: locked ? 'transparent' : 'rgba(0, 0, 0, 0.08)'
        }}}
    >
       <Box sx={{ backgroundColor: accountTabValue === matchName ? 'primary.main' : 'transparent',
           width: 5, height: 20, borderRadius: 1}} />
        <Typography variant='subtitle2' color={locked ? 'text.secondary' : 'primary.main'}>{label.toUpperCase()}</Typography>
        {locked && (
          <Tooltip title={lockTooltip ?? "Sign In to Access"} placement="right">
            <LockIcon sx={{ fontSize: 14, ml: 'auto', color: 'text.secondary' }} />
          </Tooltip>
        )}
    </Stack>
  )
}

export default MenuSpanHeader;
